import type { FolderBreadcrumbItem } from '@/types/SixDetail.types';

/**
 * Converts a Six folder path into the breadcrumb trail shown in the detail view.
 */
export function parseBreadcrumbFromPath(
  currentPath: string | undefined,
  rootLabel: string,
): FolderBreadcrumbItem[] {
  const root: FolderBreadcrumbItem = {
    id: 'six-root',
    label: rootLabel,
  };

  if (currentPath === undefined || currentPath === '/') {
    return [root];
  }

  const segments = currentPath
    .replace(/\/+$/, '')
    .split('/')
    .filter(Boolean);

  const items = segments.map((segment, index) => ({
    id: `/${segments.slice(0, index + 1).join('/')}`,
    path: `/${segments.slice(0, index + 1).join('/')}`,
    label: segment,
  }));

  return [root, ...items];
}
